__turbopack_context__.v({
  "image": "_6VqvTW_image",
  "placeholder": "_6VqvTW_placeholder",
  "root": "_6VqvTW_root",
});
